export default {
  state: {
    id: undefined,
    email: undefined,
    authtype: undefined,
    start_ts: undefined,
    end_ts: undefined,
    purchase: {},
    purchase_id: undefined,
    purchasable_item_id: undefined,
    purchasable_item: {},
    purchasable_items: [],
    puzzle_link_id: undefined,
    user_id: undefined,
    created_at: undefined,
    updated_at: undefined,
    about_to_expire: undefined,
    expiring_soon: undefined,
    status: undefined
  }
}



// WEBPACK FOOTER //
// ./src/stores/SubscriptionStore.js